const $$splitComponentImporter = () => import('/app/src/routes/dashboard/route.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
import { fetchAuthSession } from "@/api-queries/auth";
export const Route = createFileRoute("/dashboard")({
  beforeLoad: async ({
    context
  }) => {
    const session = await fetchAuthSession();
    if (!session?.user) throw redirect({
      to: "/login"
    });
    return {
      session
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});